const header = [
	{
		'name': "سلعة",
		'id': 0,
		'isActive': false
	},
	{
		'name': "تفاصيل",
		'id': 1,
		'isActive': false
	},
	{
		'name': "تسجيل",
		'id': 2,
		'isActive': false
	}
];


export {
	header,
}
